"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintLayout = void 0;

/**
 * Represents a mail template, to be saved inside a Subcollection of
 * the restaurant.
 * @class
 */
class PrintLayout {
  /**
   * Mail Template constructor, wraps an existing Firestore DocumentSnapshot
   * @param {DocumentSnapshot} snap The DocumentSnapshot representing the Mail Template
   */
  constructor(snap) {
    this._snap = snap;
    this._ref = snap.ref;
    this._data = snap.data() || {};
  }

  get uuid() {
    return this._ref.id;
  }
  /**
   * The Title to be used for the Mail,
   * Supports Delivery Boostings Flavour of LiquidJS
   * @type {String}
   */


  get title() {
    return this._data.title || '';
  }

  set title(val) {
    this._data.title = val;
  }
  /**
   * The body markup of the Mail,
   * Supports Delivery Boostings Flavour of LiquidJS
   * @type {String}
   */


  get markup() {
    return this._data.markup || '';
  }

  set markup(val) {
    this._data.markup = val;
  }

  async commit() {
    await this._ref.set(this.toPlainObject());
  }

  toPlainObject() {
    return {
      title: this._data.title,
      markup: this._data.markup
    };
  }

}

exports.PrintLayout = PrintLayout;